import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Roles } from '@models/base/identificadores.model';
import { LoginService } from '@services/login/login.service';

@Injectable({
  providedIn: 'root'
})
export class RolClientGuard implements CanActivate {
  constructor(
    private loginService: LoginService
    ){
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return ( this.loginService.getIdUserRol() === Roles.Clientes) ? false : true;
  }


}
